import axios from 'axios';

// Base URL da própria aplicação (pode ser relativa)
const internalApi = axios.create({
    baseURL: '/',
});

export default internalApi;
